import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { StripeCharge } from '@/models/payment';

export const fetchStripeCharge = async (stripeChargeId: string): Promise<StripeCharge | null> => {
  const response = await queryExecute({
    query: graphql(`
      query StripeCharge($stripeChargeId: String!) {
        stripeCharge(stripeChargeId: $stripeChargeId) {
          currency
          payment_method_details
          status
          amount
          amount_refunded
          description
          created
        }
      }
    `),
    variables: {
      stripeChargeId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.stripeCharge ?? null;
};
